<template>
  <div class="courseList">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoadMore"
    >
      <div class="courseItem" v-for="(item, index) in list" :key="index" @click="navToDetail(item)">
        <div class="img_box">
          <img :src="item.poster">
        </div>
        <div class="info_box">
          <p class="name" style="-webkit-box-orient: vertical;">{{item.title}}</p>
          <p class="price">￥{{item.price}}元 / {{item.termMonthDes}}</p>
          <div class="desc">
            <p class="item"
              v-for="(tag, tagIndex) in item.tags"
              :key="tagIndex"
            >
              <span class="dian"></span>
              <span class="text">{{tag}}</span>
            </p>
          </div>
        </div>
        <div class="next_icon">
          <van-icon name="arrow" color="#4CB2B6" size="18" />
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {
  ApiCourseware,
  ApiMyCourseware
} from '../../../api/onlineLearning.js'
import { GetNextMonthDay, parseTime } from "../../../utils/index.js"
import { Icon } from 'vant'
import { List } from 'vant'

export default {
  name: 'courseList',
  components: {
    vanIcon: Icon,
    vanList: List
  },
  filters: {
    termMonthFilter(value) {
      let date = parseTime(new Date().getTime(), '{y}-{m}-{d}')
      if (value == 0) {
        return '永久'
      } else {
        let str = GetNextMonthDay(date, value)
        return str + '到期'
      }
    }
  },
  // type: 1-课程市场 2-我的课程
  props: ['cateId', 'type'],
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      limit: 10,
      list: []
    }
  },
  watch: {
    cateId: function(value) {
      if (value) {
        this.page = 1
        this.loading = false
        this.finished = false
        this.list = []
        this.requestCourseList()
      }
    }
  },
  mounted() {
    if (this.type == 2) {
      this.requestCourseList()
    }
  },
  methods: {
    onLoadMore() {
      if (this.page === 1 || this.finished) return false

      this.requestCourseList()
    },
    // 课程列表
    async requestCourseList() {
      let cateId = this.cateId
      if (this.type == 1) {
        if (!cateId) {
          this.finished = true
          this.loading = false
          return false
        }
      }

      let params = {
        SkipCount: (this.page - 1) * this.limit,
        MaxResultCount: this.limit
      }

      if (this.type == 1) {
        params.CateId = cateId
      }

      let res
      if (this.type == 1) {
        // 课程市场
        try {
          res = await ApiCourseware(params)
        } catch (error) {
          this.finished = true
          this.loading = false
          return false
        }
      } else if (this.type == 2) {
        // 我的课程
        try {
          res = await ApiMyCourseware(params)
        } catch (error) {
          this.finished = true
          this.loading = false
          return false
        }
      }

      if (res.code === 200) {
        let data = res.data.items.map(ele => {
          ele.tags = ele.tags ? ele.tags.split(',') : []

          return ele
        })
        console.log(this.page)
        if (this.page === 1) {
          this.list = data
        } else {
          this.list = this.list.concat(data)
        }

        if (data.length < this.limit) {
          this.loading = false
          this.finished = true
        } else {
          this.page++
          this.loading = false
        }
      } else {
        this.finished = true
        this.loading = false
      }
    },
    navToDetail(item) {
      // this.$router.push({ path: '/onlineLearning/test', query: { id: item.id, type: this.type } })
      this.$router.push({ path: '/onlineLearning/courseDetail', query: { id: item.id, type: this.type } })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/flexable.scss';

.courseList {
  width: 100%;
  padding-bottom: px2rem(37);
  .courseItem {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: px2rem(30);
    width: 100%;
    padding: px2rem(30) px2rem(38) px2rem(30);
    border: 2px solid #E8EEEF;
    border-radius: px2rem(20);
    background-color: #fff;
    box-sizing: border-box;
    &:last-child {
      margin-bottom: 0;
    }
    .img_box {
      margin-right: px2rem(37);
      flex: 0 0 px2rem(142);
      height: px2rem(142);
      border-radius: px2rem(30);
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .info_box {
      flex: 1;
      text-align: left;
      .name {
        display: -webkit-box !important;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        -webkit-line-clamp: 2;

        margin-bottom: px2rem(18);
        line-height: 1.2;
        max-height: px2rem(62);
        font-size: px2rem(28);
        font-weight: bold;
        color: #1f1f1f;
      }
      .price {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: px2rem(18);
        line-height: px2rem(34);
        font-size: px2rem(30);
        font-weight: bold;
        color: #1f1f1f;
      }
      .desc {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        line-height: px2rem(28);
        .item {
          display: flex;
          align-items: center;
          margin-right: px2rem(20);
          .dian {
            margin-right: px2rem(11);
            flex: 0 0 px2rem(6);
            height: px2rem(6);
            border-radius: 50%;
            background-color: #90909F;
          }
          .text {
            font-size: px2rem(24);
            color: #8D8D8D;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>